module.exports = __webpack_public_path__ + "static/media/1 23 hvert.e5744d07.mp3";